module.exports = {"140931100":"东关镇","140931101":"义门镇","140931102":"桥头镇","140931103":"杨家湾镇","140931200":"腰庄乡","140931201":"韩家川乡","140931202":"林遮峪乡","140931203":"冯家川乡","140931204":"土崖塔乡","140931205":"孙家沟乡","140931206":"窑洼乡","140931207":"窑圪台乡","140931208":"南河沟乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140931.json
// module id = 357
// module chunks = 0